export default "__VITE_ASSET__2c658863__"